import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Prescription } from './prescription';
export { Prescription };
import { prescriptionSchema } from '@schemas/business-objects/prescription';
import { CurriculumFormGroup } from './curriculum-form-group';
import { StudentFormGroup } from './student-form-group';

export class PrescriptionFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    active: SchemaFormControl;
    oralReadingFluency: SchemaFormControl;
    studentId: SchemaFormControl;
    student: StudentFormGroup;
    curriculumId: SchemaFormControl;
    curriculum: CurriculumFormGroup;
  };

  declare value: Partial<Prescription>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(prescriptionSchema, Prescription, data, options);
  }

  get object(): Prescription {
    return new Prescription(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'student':
        return new StudentFormGroup();
      case 'curriculum':
        return new CurriculumFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<Prescription[]> {
    return Prescription.find(filter);
  }

  static async findOne(filter?: any): Promise<Prescription | null> {
    return Prescription.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<Prescription> {
    return Prescription.findById(id, filter);
  }

  static async create(data: Partial<Prescription>): Promise<Prescription> {
    return Prescription.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<Prescription>,
  ): Promise<Prescription> {
    return Prescription.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return Prescription.deleteById(id);
  }
}

export class PrescriptionFormArray extends PersistedFormArray {
  readonly entityName = 'Prescription' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(prescriptionSchema, Prescription, options);
  }

  protected override createItemGroup() {
    return new PrescriptionFormGroup();
  }

  get array(): Prescription[] {
    return this.controls.map((group: PrescriptionFormGroup) => group.object);
  }
}

export class PrescriptionPersistedArray extends PersistedArray<Prescription> {
  readonly entityName = 'Prescription' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Prescription, options);
  }
}
